export enum BookingSystemCodesEnum {
    U1 = "U1"
}